import { BaseService } from 'core/services';
import ContactDepartmentRouteService from './ContactDepartmentRouteService';

class ContactDepartmentService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ContactDepartmentRouteService());
    }
}

export default ContactDepartmentService;